module.exports = __webpack_public_path__ + "img/content_mo_ui5.1eb49fe4.png";